/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';

import SigninForm from './forms/definitions/SigninForm';
import FormSignin from './forms/FormSignin';

@observer
export default class SignIn extends Component {
    render() {
        // const { username, password } = this.props;
        return (
            <div className="row">
                <div className="col-12 signin">
                    <FormSignin className="form-signin" form={SigninForm} />
                </div>
            </div>
        );
    }
}
